import { generateAutomationName } from "../../helpers/generateAutomationName";

export const ALERTS_BUTTON_DATA_AUTOMATION = generateAutomationName("home", ["alerts", "indication", "button"]);
